import { useViewportSize as useViewportSizeFromBlocks } from "@overmap-ai/blocks"
import { memo, type PropsWithChildren } from "react"

import { BREAKPOINTS } from "../../constants"
import { ViewportSizeContext } from "./context"

export const ViewportSizeProvider = memo<PropsWithChildren>((props) => {
	const { children } = props
	const viewportData = useViewportSizeFromBlocks(BREAKPOINTS)

	return <ViewportSizeContext.Provider value={viewportData}>{children}</ViewportSizeContext.Provider>
})
ViewportSizeProvider.displayName = "ViewportSizeProvider"
